module.exports = __webpack_public_path__ + "img/cagehosth.e4621dbe.svg";